<script setup>
import { onMounted } from 'vue'

import PlatformList from '@/components/ui/PlatformList.vue';

const props = defineProps({
	stream: {
		type: Object,
		required: true,
		validator(v) {
			return Object.prototype.hasOwnProperty.call(v, '_id');
		}
	},
	mediaPulse: {
		type: Object,
		default() { return {}; }
	}
})

onMounted(async () => {
	await window.trackEvent('Page Viewed', {
		page: 'Stream Dashboard',
		streamId: props.stream._id,
		streamType: props.stream.type,
	});
})

const emit = defineEmits({
	'refresh-stream': () => true,
	'stream-updated': () => true,
})

const requestStreamRefresh = (cb) => {
	emit('refresh-stream', cb);
}
const onPlatformListUpdated = (platformList) => {
	emit('stream-updated', { platforms: platformList });
}
</script>

<template>
	<div>
		<div class="content-container">
			<platform-list :stream="stream" :media-pulse="mediaPulse" @platform-list="onPlatformListUpdated"
				@refresh-stream="requestStreamRefresh" />
		</div>
	</div>
</template>
